import {ACTION_TYPES} from "../consts";
import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {BookmakerDomainModel} from "../../domain/common/bookmaker/models/bookmaker-domain-model";
import {BookmakerViewModel} from "../../domain/common/bookmaker/models/bookmaker-view-model";
import {PartialGameDataSource} from "../../domain/partial-game/models/partial-game-data-source";

export class PopulateSponsorshipBookmakerHandler extends ActionHandler {
  type = ACTION_TYPES.populateSponsorshipBookmaker;
  static injectables = [...ActionHandler.injectables];

  onDataSourcePopulating(dataSource: PartialGameDataSource) {
    const bookmakerDomainModel: BookmakerDomainModel = dataSource?.bookmakers?.first();
    const bookmakerViewModel: BookmakerViewModel = bookmakerDomainModel && new BookmakerViewModel(bookmakerDomainModel);

    if (bookmakerViewModel) {
      this.state.appState.sponsoredBookmaker = bookmakerViewModel;
    }
  }
}
